import { COUNTRY_CONFIG } from "../utils";

const HatchSwatch = ({ id, color }: { id: string; color: string }) => (
  <svg width={14} height={14} style={{ flexShrink: 0 }}>
    <defs>
      <pattern
        id={id}
        patternUnits="userSpaceOnUse"
        width={4}
        height={4}
        patternTransform="rotate(45)"
      >
        <rect width={4} height={4} fill={color + "2e"} />
        <line x1={0} y1={0} x2={0} y2={4} stroke={color} strokeWidth={1.5} />
      </pattern>
    </defs>
    <rect width={14} height={14} rx={2} fill={`url(#${id})`} stroke={color} strokeWidth={1} />
  </svg>
);

const HolidayLegend = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 16,
      marginBottom: 8,
      paddingLeft: 16,
      fontSize: 12,
    }}
  >
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      <HatchSwatch id="legend-ro" color={COUNTRY_CONFIG.RO.color} />
      {COUNTRY_CONFIG.RO.label} Public Holiday
    </span>
    <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
      <HatchSwatch id="legend-ge" color={COUNTRY_CONFIG.GE.color} />
      {COUNTRY_CONFIG.GE.label} Public Holiday
    </span>
  </div>
);

export default HolidayLegend;
